import React, { useState } from 'react'
import './Navbar.scss'

import { Nav, Navbar } from 'react-bootstrap'
import { Link } from 'react-scroll'
import { isMobile } from 'react-device-detect'

import classNames from 'classnames'

import { useScrollPosition } from '@n8tb1t/use-scroll-position'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

const NavbarContainer = (props) => {
  const [backgroundVisible, changeBackgroundVisible] = useState(false)
  const [expanded, changeExpanded] = useState(false)
  const vh = -1 * Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  const vhOfItem = 200

  useScrollPosition(({ currPos }) => {
    if (vh + vhOfItem >= currPos.y && !backgroundVisible) {
      changeBackgroundVisible(!backgroundVisible)
    }
    if (vh + vhOfItem <= currPos.y && backgroundVisible) {
      changeBackgroundVisible(!backgroundVisible)
    }
  })

  const scrollTime = 800
  let navbarItemsList = null

  navbarItemsList = props.itemsInNavbar.map((item, index) => {
    return (
      <Nav.Item className="navbar__element" key={'navbarItem' + index}>
        <Link
          className="navbar__link"
          onClick={()=>changeExpanded(!expanded)}
          activeClass="navbar__link--active"
          to={item.name}
          spy={true}
          smooth={true}
          offset={-50}
          duration={scrollTime}
          href="/"
        >
          {item.title}
        </Link>
      </Nav.Item>
    )
  })

  const classValue = classNames({
    navbar: true,
    'navbar--withBackground': backgroundVisible === true
  })

  const toggleMenuVisible = classNames({
    navbar__toggle__space:true,
    'navbar__toggle__space--active': backgroundVisible === true
  })

  return (
    <Navbar className={classValue} expand="lg" expanded={isMobile? expanded : true}>
      <Navbar.Toggle onClick={()=>changeExpanded(!expanded)} className="navbar__toggle" aria-controls="basic-navbar-nav ml-auto">
        <div className={toggleMenuVisible}>
          <FontAwesomeIcon icon={faBars} className="navbar__toggle__icon" />
        </div>
      </Navbar.Toggle>
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="navbar__list">{navbarItemsList}</Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default NavbarContainer
